/**
 * Calendar date `YYYY-MM-DD` in the viewer's local timezone.
 */
export function formatLocalYmd(d: Date): string {
  if (!d || !(d instanceof Date) || Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Minutes to add to UTC to get local civil time (common API convention).
 * Negates {@link Date#getTimezoneOffset}, which returns "UTC − local" in minutes.
 */
export function getViewerUtcOffsetMinutes(): number {
  return -new Date().getTimezoneOffset();
}

/** Parse `YYYY-MM-DD` as local midnight; returns null if invalid. */
export function parseLocalYmd(ymd: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd.trim());
  if (!match) return null;
  const d = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

/** Clamp an ISO date string so it is not after today (local). */
export function clampYmdToToday(ymd: string): string {
  const today = formatLocalYmd(new Date());
  return ymd > today ? today : ymd;
}
